import { cache } from "react";
import axios from "utils/axiosInstance";


const getAddressList = cache(async (page = 1, vendors_id) => {


  const params = {
    page,
    per_page: 1,
    ...(vendors_id ? { vendor_id: vendors_id[0] } : null),
    ...(vendors_id ? { vendors_id: vendors_id } : null)

  };

  const {
    data: addressList
  } = await axios.get("/api/delivery/addresses", { params });

  const totalPages = 1;
  let response = {}
  if (addressList) {
    response = {
      addressList: addressList,
      totalOrders: addressList.length,
      totalPages
    };
  }

  return response;
});
const getIds = cache(async () => {
  const response = await axios.get("/api/address/address-ids");
  return response.data;
});

const getGoogleAddress = cache(async (address, minimal = true) => {

  const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY;
  address = address.replace(/ /g, "+");
  let url = ''

  if (minimal) {
    url = `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${address}&key=${apiKey}&region=MX`
  } else {
    url = `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${address}&key=${apiKey}&location=${myLatLng}&region=MX`;
  }

  const response = await axios.get(url);
  return response
})


const postNewAddress = cache(async (token, data) => {

  const response = await axios({
    method: 'POST',
    url: "/api/delivery/addresses",
    headers: { "Authorization": token },
    data: data
  });
  return response.data;
})

const updateAddress = cache(async (data, id) => {

  const response = await axios({
    method: 'PUT',
    url: "/api/delivery/addresses/" + id,
    data: data
  });
  return response.data;
})

const destroyAddress = cache(async (id) => {

  const response = await axios({
    method: 'DELETE',
    url: "/api/delivery/addresses/" + id,
  });
  return response.data;
})

const getAddress = cache(async (id) => {

  const response = await axios({
    method: 'GET',
    url: "/api/delivery/addresses/" + id,

  });
  return response.data;
});
export default {
  getAddressList,
  getIds,
  getAddress,
  getGoogleAddress,
  postNewAddress,
  updateAddress,
  destroyAddress
};